import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ProjectUserItem } from "@ServerTypes/projects/project.schema";
import type { SpaceUserFromAllUsersInSpace } from "@ServerTypes/accounts/accounts.schema";

export type { ProjectUserItem };
export type { SpaceUserFromAllUsersInSpace as SpaceUserItem };

const projectUsersSlice = createSlice({
  name: "projectUsers",
  initialState: [] as ProjectUserItem[],
  reducers: {
    setProjectUserDetails: (_state: ProjectUserItem[], action: PayloadAction<ProjectUserItem[]>) => action.payload,
  },
});

const spaceUsersSlice = createSlice({
  name: "spaceUsers",
  initialState: [] as SpaceUserFromAllUsersInSpace[],
  reducers: {
    setSpaceUserDetails: (
      _state: SpaceUserFromAllUsersInSpace[],
      action: PayloadAction<SpaceUserFromAllUsersInSpace[]>,
    ) => action.payload,
  },
});

const userInProjectSlice = createSlice({
  name: "userInProject",
  initialState: [] as ProjectUserItem[],
  reducers: {
    setUsersInProject: (_state: ProjectUserItem[], action: PayloadAction<ProjectUserItem[]>) => action.payload,
  },
});

export const { setProjectUserDetails } = projectUsersSlice.actions;
export const { setSpaceUserDetails } = spaceUsersSlice.actions;
export const { setUsersInProject } = userInProjectSlice.actions;

export const projectUsers = projectUsersSlice.reducer;
export const spaceUsers = spaceUsersSlice.reducer;
export const UserInProject = userInProjectSlice.reducer;

export default projectUsersSlice.reducer;
